module.exports = __webpack_public_path__ + "wilkinson-big.jpg?eb23c3040e335b89ef17965891e6a1f7";